import { FC } from 'react';
import Card from '../Card/Card';
import { IconAlert } from '../../icons/Icons';
import language from '../../util/language';
import common from '../../util/scss/common.module.scss';

const MultiFactorAuthExpired: FC = () => {
    return (
        <Card>
            <section className={`${common.icon}`}>
                <IconAlert width={'65'} height={'65'} fillColor={'#696C74'} />
            </section>
            <header>
                <h1 className={`${common.pageHeader} ${common.withSubhead}`}>
                    {language.confirmStaffAccount.expired.header}
                </h1>
                <p className={`${common.pageSubhead}`} data-testid={'verify-desc'}>
                    {language.confirmStaffAccount.expired.desc}
                </p>
            </header>
        </Card>
    );
};

export default MultiFactorAuthExpired;
